import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-box',
  templateUrl: 'box.component.html',
  styleUrls: ['box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViBoxComponent {
  @Input() isBoxControl: Boolean = false;
  @Input() isDarkMode = false;

  getGap(): string {
    return this.isBoxControl ? '27px' : '15px';
  }
}
